import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { createBillingLinkRequest } from '../../../actions/user';

const email_re =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const ConsolidatedBillingRequestForm = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [pristine, setPristine] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    const { value } = event.target;
    setEmail(value);
    setPristine(false);
    setError(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const valid = email_re.test(email);
    if (!valid) {
      setError(true);
      return;
    }
    setSubmitting(true);
    await dispatch(createBillingLinkRequest(email));
    setSubmitting(false);
  };

  return (
    <Box component='form' onSubmit={handleSubmit}>
      <Typography paragraph>
        To submit a request to another user to link your account to their credit
        pool, enter the email address of their {import.meta.env.VITE_ORG_NAME}{' '}
        account below:
      </Typography>
      <TextField
        fullWidth
        label='Consolidated Billing Account Email'
        name='email'
        value={email}
        onChange={handleChange}
        placeholder='cto@mydomain.com'
        error={error}
        helperText={error ? 'Please enter a valid email address' : ''}
        required
        sx={{ mb: 2 }}
      />
      <Button
        variant='contained'
        color='primary'
        type='submit'
        disabled={pristine || error}
        startIcon={
          submitting ? (
            <CircularProgress size={20} color='inherit' />
          ) : (
            <SendIcon />
          )
        }
      >
        {submitting ? 'Sending Request...' : 'Send Request'}
      </Button>
    </Box>
  );
};

export default ConsolidatedBillingRequestForm;
